import React from 'react';
import {Container} from "react-bootstrap";
import systemDetails from "../imgs/appointmentsystemn.jpg";
import Footer from "../components/Footer";

function Home() {
    return (
        <main className="my-5 mx-0">
            <Container className="container-fluid full-height-container">
                <div className="p-4 p-md-5 mb-4 rounded text-body-emphasis">
                    <div className="col-lg px-0 text-center">
                        <h1 className="display-4 fst-normal">
                            Allow your Customer to Schedule <br/> Appointment through <br/>WhatsApp
                        </h1>
                        <p className="lead my-3">
                            Automate replies, Schedule messages, No extra application for your customer, <br/>
                            all inside WhatsApp.
                        </p>
                    </div>
                    <div className="p-4 p-md-5 mb-4 rounded text-body-emphasis text-center">
                        <img src={systemDetails} alt="Rushta Schedule System"
                             className="img-fluid systemDetails-image"/>
                    </div>
                </div>
            </Container>
            <Footer/>
        </main>
    );
}

export default Home;